/**
 * StudentTabBar — le `tabBar` React Navigation de l'espace élève : le `<BottomTab>` du DS sur les
 * trois onglets de l'élève (`TABS_BY_TYPE.student`). Calque de `ParentTabBar`.
 *
 * La pastille de « Messages » ne compte que les messages non lus (Wajih, 19/10) : la barre la lit
 * dans le store (`studentMessagesBadge`). La coquille legacy, elle, y ajoutait la visio du jour et
 * les lives qui commencent bientôt, qui ont quitté l'onglet.
 *
 * Sur le web, chaque onglet est un lien vers son adresse (`useLinkBuilder`, comme la barre de React
 * Navigation que l'ancien espace montait) : Ctrl ou Cmd-clic l'ouvre dans un autre onglet, et « Copier
 * le lien » marche.
 */
import React from "react"
import { Platform } from "react-native"
import type { BottomTabBarProps } from "@react-navigation/bottom-tabs"
import { useLinkBuilder } from "@react-navigation/native"
import { useSelector } from "react-redux"

import { BottomTab, TABS_BY_TYPE } from "../../../../../design-system"
import { studentMessagesBadge } from "../../../view-models/student/Tutoring/studentTutoringViewModel"
import { routeNameToTabKey, tabKeyToRouteName, type StudentTabKey } from "./studentRoutes"

export function StudentTabBar(props: BottomTabBarProps) {
    const { state, navigation } = props
    const tutorBadge = useSelector(studentMessagesBadge)
    const routeName = state.routes[state.index]?.name ?? "home"
    const { buildHref } = useLinkBuilder()
    const hrefs =
        Platform.OS === "web"
            ? Object.fromEntries(
                  state.routes.map((route) => [routeNameToTabKey(route.name), buildHref(route.name, route.params)])
              )
            : undefined

    return (
        <BottomTab
            tabs={TABS_BY_TYPE.student}
            activeKey={routeNameToTabKey(routeName)}
            badges={tutorBadge > 0 ? { tutor: tutorBadge } : undefined}
            hrefs={hrefs as Partial<Record<StudentTabKey, string>> | undefined}
            onTabChange={(key) => {
                const route = tabKeyToRouteName(key)
                // Un nom que le navigateur n'enregistre pas ferait planter `navigate`.
                if (route && state.routeNames.includes(route)) navigation.navigate(route)
            }}
        />
    )
}
